"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var FormContext_1 = require("../Context/FormContext");
var ValuationWidgetContext_1 = require("../Context/ValuationWidgetContext");
var DropDownOption_1 = __importDefault(require("./DropDownOption"));
var YearMakeModelDropDowns = function () {
    var _a;
    var widgetContext = (0, hooks_1.useContext)(ValuationWidgetContext_1.ValuationWidgetContext);
    var formContext = (0, hooks_1.useContext)(FormContext_1.FormContext);
    (0, hooks_1.useEffect)(function () {
        var _a = formContext.formValue.yearMakeModel, year = _a.year, make = _a.make, model = _a.model;
        switch (true) {
            case (!year && !make && !model):
                // Clearing Year
                widgetContext.updateDropdownFromSelectedYear(null);
                return;
            case (!make && !model):
                // Getting Make
                widgetContext.updateDropdownFromSelectedYear(year);
                return;
            case (!model):
                // Getting Model
                widgetContext.updateDropdownFromSelectedYearAndMake(year, make);
                return;
        }
    }, [formContext.formValue.yearMakeModel]);
    (0, hooks_1.useEffect)(function () {
        var models = widgetContext.selectionValues.dropdowns.models;
        if (models.length !== 1)
            return;
        updateModel(models[0]);
    }, [widgetContext.selectionValues.dropdowns.models]);
    var getDropDownOptions = function () { return widgetContext.selectionValues.dropdowns; };
    var updateYear = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            formContext.resetFormWithNewValue(function (x) {
                x.yearMakeModel = {
                    year: value,
                    make: null,
                    model: null,
                };
            });
            return [2 /*return*/];
        });
    }); };
    var updateMake = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            formContext.resetFormWithNewValue(function (x) {
                x.yearMakeModel = __assign(__assign({}, formContext.formValue.yearMakeModel), { make: value, model: "" });
            });
            return [2 /*return*/];
        });
    }); };
    var updateModel = function (value) {
        formContext.resetFormWithNewValue(function (x) {
            x.yearMakeModel = __assign(__assign({}, formContext.formValue.yearMakeModel), { model: value });
        });
    };
    var isMakeDisabled = function () {
        var makes = getDropDownOptions().makes;
        return !makes || makes.length === 0;
    };
    var isModelDisabled = function () {
        var models = getDropDownOptions().models;
        return !models || models.length === 0 || models.length === 1;
    };
    var shouldShowYearError = function () {
        return widgetContext.errors.yearMakeModel
            && !formContext.formValue.yearMakeModel.year;
    };
    var shouldShowMakeError = function () {
        return widgetContext.errors.yearMakeModel
            && formContext.formValue.yearMakeModel.year
            && !formContext.formValue.yearMakeModel.make;
    };
    var shouldShowModelError = function () {
        return widgetContext.errors.yearMakeModel
            && formContext.formValue.yearMakeModel.year
            && formContext.formValue.yearMakeModel.make
            && !formContext.formValue.yearMakeModel.model;
    };
    var shouldShowUpgradeOfferButton = function () { return !widgetContext.getShowDropdowns; };
    function getSelectionClasses() {
        var classes = "valuation-drop-downs drop-downs-selected";
        if (shouldShowUpgradeOfferButton())
            classes += "upgrade-offer ";
        return classes;
    }
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { className: getSelectionClasses() },
            (0, preact_1.h)("ul", { className: "body no-frills" },
                (0, preact_1.h)("li", { className: "modified-selectbox-wrapper" },
                    (0, preact_1.h)(DropDownOption_1.default, { elementId: "ModelYear-Widget", value: formContext.formValue.yearMakeModel.year, options: getDropDownOptions().years, defaultText: "Select Model Year", isDisabled: false, stepNumber: "1", stepNumberClass: "red", hasError: shouldShowYearError(), onChange: function (e) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, updateYear(e)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); } })),
                (0, preact_1.h)("li", { className: "modified-selectbox-wrapper" },
                    (0, preact_1.h)(DropDownOption_1.default, { elementId: "Manufacturer-Widget", value: formContext.formValue.yearMakeModel.make, options: getDropDownOptions().makes, defaultText: "Select Make", isDisabled: isMakeDisabled(), stepNumber: "2", stepNumberClass: "yellow", hasError: shouldShowMakeError(), onChange: function (e) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, updateMake(e)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); } })),
                (0, preact_1.h)("li", { className: "modified-selectbox-wrapper last" },
                    (0, preact_1.h)(DropDownOption_1.default, { elementId: "ModelName-Widget", value: formContext.formValue.yearMakeModel.model, options: getDropDownOptions().models, defaultText: "Select Model", isDisabled: isModelDisabled(), stepNumber: "3", stepNumberClass: "green", hasError: shouldShowModelError(), showAsLabel: ((_a = widgetContext.selectionValues.dropdowns) === null || _a === void 0 ? void 0 : _a.models.length) === 1, onChange: function (e) { return updateModel(e); } }))))));
};
exports.default = YearMakeModelDropDowns;
